export const businessInformationMutations = {
  setAllBusinessInformations(state, payload) {
    state.allBusinessInformations = payload;
  },
  setUserBusinessInformation(state, payload) {
    state.userBusinessInformation = payload;
  },
};
